export function Footer({changePage}) {
    return (
      <footer className="modern-footer">
        <div className="footer-container">
          <div className="footer-content">
            <span className="copyright-text">
              © Made by <span className="admin-link" onClick={() => changePage('tryAdmin')}>WONGIL</span>
            </span>
          </div>
        </div>
      </footer>
    );
  }